import { Box, Button, ButtonProps, styled } from '@mui/material';

export const DragDropBoxStyled = styled(Box)<{ isDragActive: boolean }>(
  ({ theme, isDragActive }) => ({
    border: `1px dashed ${isDragActive ? theme.palette.primary.main : '#C5CCD6'}`,
    borderRadius: '8px',
    padding: '40px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: isDragActive ? `${theme.palette.primary.light}10` : 'transparent',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  }),
);

export const UploadButtonStyled = styled(Button)<ButtonProps>(({ theme }) => ({
  fontSize: '1rem',
  lineHeight: '1.125rem',
  fontWeight: 700,
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  borderRadius: theme.spacing(2),
  '& input[type="file"]': {
    display: 'none',
  },
}));
